import React from 'react'

// Without this, an uncaught render error anywhere in the tree (e.g. a
// dashboard widget failing on unexpected data) unmounts the entire app -
// there was no error boundary anywhere before this. Scope it around
// individual sections (not just the app root) so one broken widget doesn't
// take down the whole admin panel.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{ padding: '1rem', color: '#A53860' }}>
          Something went wrong loading this section.
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
